import React from 'react';
import { StyledSvgIcon } from '../icon.styles';
import { customIconsPropTypes } from './customicons.propTypes';

const PawIcon = ({ fontSize, color, sx, title }) => (
  <StyledSvgIcon
    fontSize={fontSize}
    color={color}
    titleAccess={title}
    data-testid={title}
    aria-label={title}
    sx={sx}
  >
    <svg
      width="35"
      height="28"
      viewBox="0 0 35 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.53846 20.5C4.93969 20.5 6.07692 18.7528 6.07692 16.6C6.07692 14.4472 4.93969 12.7 3.53846 12.7C2.13723 12.7 1 14.4472 1 16.6C1 18.7528 2.13723 20.5 3.53846 20.5ZM11.1538 8.8C12.5551 8.8 13.6923 7.0528 13.6923 4.9C13.6923 2.7472 12.5551 1 11.1538 1C9.75262 1 8.61538 2.7472 8.61538 4.9C8.61538 7.0528 9.75262 8.8 11.1538 8.8ZM23.8462 8.8C25.2474 8.8 26.3846 7.0528 26.3846 4.9C26.3846 2.7472 25.2474 1 23.8462 1C22.4449 1 21.3077 2.7472 21.3077 4.9C21.3077 7.0528 22.4449 8.8 23.8462 8.8ZM31.4615 20.5C32.8628 20.5 34 18.7528 34 16.6C34 14.4472 32.8628 12.7 31.4615 12.7C30.0603 12.7 28.9231 14.4472 28.9231 16.6C28.9231 18.7528 30.0603 20.5 31.4615 20.5ZM25.1154 21.8C25.1154 25.388 21.0031 27 17.5 27C13.9969 27 9.88462 25.388 9.88462 21.8C9.88462 18.212 12.4231 12.7 17.5 12.7C22.5769 12.7 25.1154 18.212 25.1154 21.8Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </StyledSvgIcon>
);
export default PawIcon;

PawIcon.propTypes = customIconsPropTypes;
